export default __webpack_public_path__ + "static/media/wave1.dfbcf0e3.png";